import React, { InputHTMLAttributes } from "react";

import {
  Input as MagneticInput,
  InputProps as MagneticInputProps
} from "@magnetic/input";

interface InputProps extends MagneticInputProps {}

export type Ref = HTMLInputElement;

// Predefined character sets for common input restrictions
const CHAR_SETS = {
  naturalInteger: ["+", "-", ".", "e", "E"], // Blocks: signs, decimals, scientific notation
  positiveNumber: ["-"], // Blocks: negative sign only
  integer: ["."] // Blocks: decimal point only
};

export const blockInvalidChar = (
  e: React.KeyboardEvent<HTMLInputElement>,
  preset: keyof typeof CHAR_SETS
) => {
  const chars: string[] = CHAR_SETS[preset];
  return chars.includes(e.key) && e.preventDefault();
};

export const Input = React.forwardRef<Ref, InputProps>((props, ref) => {
  //@ts-ignore TODO figure out the cause of this error.input fields does something weird with props
  return <MagneticInput ref={ref} {...props} />;
});

export const InputPassword = React.forwardRef<Ref, InputProps>((props, ref) => {
  //@ts-ignore TODO figure out the cause of this error.input fields does something weird with props
  return <MagneticInput.Password ref={ref} {...props} />;
});

interface CheckboxInputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const CheckboxInput = React.forwardRef<Ref, CheckboxInputProps>(
  (props, ref) => {
    return <input ref={ref} {...props} />;
  }
);
